import { createReducer, on } from '@ngrx/store'
import * as sharedActions from './shared.action'
import { Country } from './shared.interface'

export interface SharedState {
  countries: Country[] | null
  countriesError: boolean
  loadingCountries: boolean
}

export const initialState: SharedState = {
  countries:  null,
  countriesError: null,
  loadingCountries: null,
}

export const sharedReducer = createReducer(
  initialState,

  on(sharedActions.fetchCountries, (state) => ({
    ...state, countries: null, countriesError: null, loadingCountries: true
  })),

  on(sharedActions.fetchCountriesSuccess, (state, {countries}) => ({
    ...state, countries: countries, countriesError: false, loadingCountries: false
  })),

  on(sharedActions.fetchCountriesFailed, (state) => ({
    ...state, countries: null, countriesError: true, loadingCountries: false
  })),

 


)
